import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_qayp4qgesk: FaireRetailerEntity = {
  token: "r_qayp4qgesk",
  type: "retailer",
  name: "Retailer",
  city: "San Francisco",
  state: "CA",
  country: "US",
  meta: {
    source: "api",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
